var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-snackbars',{attrs:{"objects":_vm.objects,"right":"","bottom":"","timeout":3000},on:{"update:objects":function($event){_vm.objects=$event}},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var close = ref.close;
return [_c('v-btn',{attrs:{"small":"","text":""},on:{"click":function($event){return close()}}},[_c('v-icon',[_vm._v("mdi-close")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }